Object.assign(exports, require('./event-to-doc'))
